import { Link } from 'react-router-dom'
import { useHubLang } from '../lib/i18n'
import { CONTESTS } from '../lib/hubCopy'

/**
 * The top of every Photos page (David, 10 Oct): the sub-nav — Contests and
 * Gallery — on the left, the page's own actions (its ? menu, Manage) on the
 * right, in one row instead of a stack of paragraphs.
 *
 * The tabs repeat the rail's sub-nav (AppShell, `children` on Photos), so they
 * are drawn only where the rail cannot show it: below 820px, where the rail is
 * gone (SHL-18), and on the collapsed rail. That is CSS, not a JS breakpoint,
 * for TabBar's reason — one copy of the 820px number. And only for somebody
 * who can open the gallery: a single "Contests" tab is a link to where you are.
 */
export function PhotosBar({
  section,
  canGallery,
  children,
}: {
  section: 'contests' | 'gallery'
  canGallery: boolean
  /** The page's actions, right-aligned. */
  children?: React.ReactNode
}) {
  const t = CONTESTS[useHubLang()]
  if (!canGallery && !children) return null
  // `--bare`: only the tabs, which CSS hides beside an open rail — so the
  // empty bar goes too, rather than leaving a gap at the top of the page.
  return (
    <div className={children ? 'photosbar' : 'photosbar photosbar--bare'}>
      {canGallery && (
        <nav className="tabs photosbar__tabs" aria-label={t.photosNav}>
          <Link
            className={section === 'contests' ? 'tab tab--on' : 'tab'}
            aria-current={section === 'contests' ? 'page' : undefined}
            to="/contests"
          >
            {t.tabContests}
          </Link>
          <Link
            className={section === 'gallery' ? 'tab tab--on' : 'tab'}
            aria-current={section === 'gallery' ? 'page' : undefined}
            to="/photos/gallery"
          >
            {t.tabGallery}
          </Link>
        </nav>
      )}
      {children && <div className="photosbar__actions">{children}</div>}
    </div>
  )
}
